import { createFileRoute } from '@tanstack/react-router'
import { Bell } from 'lucide-react'
import { z } from 'zod'
import { NotificationsScreen } from '@/screens/me/SCR-055-notifications'

export const Route = createFileRoute('/_app/me/notifications')({
  staticData: { screen: { id: 'SCR-055', title: 'Notifications', group: 'Me', order: 2, eyebrow: 'Needs your attention', description: 'Everything that needs your attention, newest first.', icon: Bell } },
  validateSearch: z.object({
    status: z.enum(['all', 'unread', 'archived']).optional(),
    category: z.string().max(40).optional(),
  }),
  component: NotificationsScreen,
})
